import { Typography } from '@mui/material';
import { CopyToClipboard } from 'common/components/CopyToClipboard';

type CardContentWithCopyIconProps = {
    content: string
}

export function CardContentWithCopyIcon({
    content
}: Readonly<CardContentWithCopyIconProps>) {
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                flexWrap: 'wrap',
            }}
        >
            <CopyToClipboard
                content={content}
            />
            <Typography
                align='left'
                variant='body1'
                component='span'
                color='text.primary'
                noWrap
                sx={{
                    fontSize: '16px'
                }}
            >{content}
            </Typography>
        </div>
    );
}
